import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  register(options, data) {
    const response = Api().post(apiPath.register, data, options);
    return response;
  },

  changeRole(options, data) {
    const response = Api().post(apiPath.changeRole, data, options);
    return response;
  },

  changePassword(options, data) {
    const response = Api().post(apiPath.changePassword, data, options);
    return response;
  },

  delete(options, data) {
    const response = Api().post(apiPath.delete, data, options);
    return response;
  },

  login(options, data) {
    const response = Api().post(apiPath.login, data, options);
    return response;
  },

  logout() {
    const response = Api().get(apiPath.logout, {}, {});
    return response;
  },

  //Logged admin info avah
  adminInfo(options) {
    const response = Api().post(apiPath.adminInfo, {}, options);
    return response;
  },

  //id-gaar adminii medeelel avah
  getAdmin(options, data) {
    const response = Api().post(apiPath.getAdmin, data, options);
    return response;
  },

  getAdminsList(options) {
    const response = Api().post(apiPath.adminsList, {}, options);
    return response;
  }
};
